export enum CountryValueEnum {
  FR = 'FR',
  UE = 'UE',
  XX = 'XX',
}
